/**
 * <PrintControl 
 *		// please describe props here
 *	/>
 *
 * - When there is a nesting tr, we use tbody as a row.
 *
 * @parent anybody
 * @children 
 * @stateful
 * @stateless
 */
import React, { PropTypes } from 'react';
import classnames from 'classnames'
import Form from 'components/Form'; 
import locale from './locale';
import FilterBy from 'template/FilterBy';
import './PrintControl.scss';

const FILTERS = ['classroom', 'class', 'teacher'];

const FILTER_OPTIONS = {
  classroom: {
    selectMultiple: true,
  },
  class: {
    selectMultiple: true,
  },
  teacher: {
    selectMultiple: true,
  },
}

class PrintControl extends React.Component {
  constructor(props) {
    super(props);
    this.state = {

    }

    this.onChange = this.onChange.bind(this);
  }

  componentWillMount() {

  }

  onChange(newSetting) {
    this.props.onChange(newSetting);
  }
  
  render() {
    const {
      setting,
    } = this.props;
    
    const schoolId = localStorage.getItem('schoolId');
        
    const schemaLeft = [
      {
        name: 'scheduleType',
        label: __('Choose type:', locale),
        type: 'radio',
        fieldStyle: 'inline',
        options: [
          { label: __("Weekly", locale), value: 'weekly' },
          { label: __("Daily", locale), value: 'daily' },
        ],
        defaultValue: 'weekly',
      },
      {
        name: 'filter',
        type: 'custom',
        className: 'Filter', 
        component: (value = {}, onChange)=>{
          return ( 
            <FilterBy
              filterData={value}
              selectMultiple={true}
              filters={FILTERS}
              options={FILTER_OPTIONS}
              schoolId={schoolId}
              onChange={(data)=>{
                onChange(data.filterData);
              }} />
          );
        }
      },
    ];

    const schemaRight = [
      {
        name: 'displayLessonName',
        placeholder: __('Show Lesson Name', locale),
        type: 'checkbox',
        fieldStyle: 'inline',
        defaultValue: true,
      },
      {
        name: 'displayTeacherName',
        placeholder: __('Show Teacher Name', locale),
        type: 'checkbox',
        fieldStyle: 'inline',
        defaultValue: true,
      },
      {
        name: 'displayClassroom',
        placeholder: __('Show Classroom', locale),
        type: 'checkbox',
        fieldStyle: 'inline',
        defaultValue: true,
      },
      {
        name: 'print',
        type: 'custom',
        component: (value = {}, onChange)=>{
          return ( 
            <a className='btn btn-primary' onClick={this.props.onPrint}>{__('Print', locale)}</a>
          );
        }
      },
    ];

    return (
      <div className='PrintControl'>
        <div className='row'>
          <div className='col-sm-2'>
            <h1>{__('Print Class Schedule', locale)}</h1>
          </div>   
          <div className='col-sm-4'>
            <Form
              onChange={this.onChange} 
              schema={schemaLeft} 
              formData={setting}
              formStyle='outline'
              getValidationRef={(fn)=>{
                this.validate = fn; 
              }} 
            />
          </div>
          <div className='col-sm-6 DisplayOptions'>
            <label>{__('Display Options:', locale)}</label> 
            <Form
              onChange={this.onChange} 
              schema={schemaRight} 
              formData={setting}
              formStyle='outline'
              getValidationRef={(fn)=>{
                this.validate = fn; 
              }} 
            />
          </div>
        </div>
      </div>
    )
  }
}

export default PrintControl;



// WEBPACK FOOTER //
// ./src/containers/pages/PrintSchedule/PrintControl.js